import React from 'react';
import { twMerge } from 'tailwind-merge';
import { tv } from 'tailwind-variants';

import { Text, TextProps } from '@elements/text';

import { RegionResidencyLabel } from '../regionResidencyLabel';

export interface ContainerProps {
  titleText?: string;
  subTitleText?: string;
  descriptionText?: string;
  titleClassName?: React.HTMLAttributes<HTMLHeadingElement>['className'];
  descriptionClassName?: React.HTMLAttributes<HTMLHeadingElement>['className'];
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
  children?: React.ReactNode;
  titleVariant?: TextProps['variant'];
  subTitleVariant?: TextProps['variant'];
  subTitleClassName?: React.HTMLAttributes<HTMLHeadingElement>['className'];
  descriptionVariant?: TextProps['variant'];
  hasRegionResidencyStatus?: boolean;
  size?: 'content' | 'xl';
}

const containerStyle = tv({
  base: 'mx-auto px-s16 py-s16 w-full',
  variants: {
    size: {
      content: 'lg:max-w-6xl',
      xl: 'max-w-xl',
    },
  },
});

export const Container = ({
  titleText,
  subTitleText,
  descriptionText,
  className,
  titleClassName,
  descriptionClassName,
  titleVariant,
  children,
  hasRegionResidencyStatus,
  subTitleVariant,
  subTitleClassName,
  descriptionVariant,
  size = 'content',
}: ContainerProps) => {
  return (
    <div className={containerStyle({ size, className })}>
      {hasRegionResidencyStatus && <RegionResidencyLabel />}
      {titleText && (
        <Text
          variant={titleVariant ?? { sm: 'h3-28/freely', lg: 'h2-36/freely' }}
          className={twMerge('pt-8 text-center', !subTitleText && 'pb-5', titleClassName)}>
          {titleText}
        </Text>
      )}
      {subTitleText && (
        <Text
          variant={subTitleVariant ?? { sm: 'h3-28/freely', lg: 'h2-36/freely' }}
          className={twMerge('pb-5 text-center', subTitleClassName)}>
          {subTitleText}
        </Text>
      )}
      {descriptionText && (
        <Text
          variant={descriptionVariant ?? 'body-16/m'}
          className={twMerge('pb-4 text-center', descriptionClassName)}>
          {descriptionText}
        </Text>
      )}
      {children}
    </div>
  );
};
